import InfoCard from "components/Cursos/InfoCard";
import React from "react";
import textura from "../../media/TEXTURA-AZUL.png";
import CircularText from "components/Cursos/CircularText";
import WhyCard from "components/Index/WhyCard";

const HeaderA = ({ titulo, info, img }) => {
  return (
    <section className="">
      <div className="relative  w-full flex flex-row justify-between items-end p-40 bg-primario text-secundario overflow-hidden">
        <h1 className="w-max text-5xl md:text-8xl font-Bebas">{titulo}</h1>
        <div className=" bottom-0 right-0">
          <CircularText w={200} text="Aprende inglés en Brighton * " />
        </div>
        {/* <img width={1920} className="absolute w-[1920px] h-full object-cover" src={textura} alt="" /> */}
      </div>
      <div>
        <img src={img} alt={titulo} width={1920} loading="lazy" className="w-full h-[60vh] object-cover"/>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4  m-20 xl:m-40">
        {info
          ? info.map((inf, index) => (
              <WhyCard key={index} titulo={inf.titulo} descripcion={inf.descripcion} icono={inf.icon}/>
              // <InfoCard
              //   key={index}
              //   titulo={inf.titulo}
              //   descripcion={inf.descripcion}
              //   icon={inf.icon}
              // />
            ))
          : "Put here the info about the course "}
      </div>
    </section>
  );
};

export default HeaderA;
